export const TABLE_PLANS = ["GAU50", "GAU100", "GAU150", "GAU200", "TCP25", "TCP50", "TCP100"];
